module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/nfl/survive/yardage-138703350d6358d2145f7a32ca20309e.svg";